var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHibbertOkta({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 104.8",
    style: {
      enableBackground: "new 0 0 103 104.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#009BDE;stroke:#009BDE;stroke-width:10;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hibbert_Okta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.1,94.6c-24,0-42-17.9-42-42.3s18-42.3,42-42.3s42,17.9,42,42.3S75.1,94.6,51.1,94.6z M51.1,17.4 C30.4,17.4,18,33.7,18,52.2S30.4,87,51.1,87s33.1-16.3,33.1-34.8S71.8,17.4,51.1,17.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHibbertOkta);
export default __webpack_public_path__ + "static/media/Hibbert_Okta.e190ae1b7675cadc02494df7319169be.svg";
export { ForwardRef as ReactComponent };